export const tipoFormaPagamento = {
  0: 'Boleto',
  1: 'Cartão de Crédito',
} as const;

export type TipoFormaPagamentoKeys = keyof typeof tipoFormaPagamento;
